import { DeleteTruckModel, TruckModel, TruckModelBase } from "../trucks/TruckModels";
import { LocationModel, PersonModel, FilterInfo, DeletedReasonModel, PhoneNumberModel, EmailModel, CompanyDataModel } from "../common/models/CommonModels";
import api from "../utils/api";
import { createFilterUrl } from "./apiFilterUtils";
import * as moment from 'moment'
import { momentToDtoString } from "../utils/dateUtilities";
import { RecurrenceModel } from "../common/models/Recurrence";


interface TruckDto extends TruckModelBase<LocationModel, string> {
    id: string;
    company: CompanyDataModel<PhoneNumberModel, EmailModel>;
    coordinator: PersonModel;
    reportNumber: string;
    recurrence: RecurrenceModel;
}

const getEndpoint = "api/trucks";

export const addTruck = (data: TruckModel) => {

    const truck = {
        ...data,
        availableFrom: momentToDtoString(data.availableFrom),
        availableTo: momentToDtoString(data.availableTo),
        recurrence: {
            ...data.recurrence,
            startDate: data.recurrence.startDate ?
                momentToDtoString(data.recurrence.startDate) : data.recurrence.startDate,
            endDate: data.recurrence.endDate ?
                momentToDtoString(data.recurrence.endDate) : data.recurrence.endDate
        }
    };

    return api.post('api/trucks', truck).then(response => {
        if (response.status === 200) {
            return true;
        }
        return false;
    }).catch(error => {
        console.log(error);
        return false;
    });
}

export const editTruck = (data: TruckModel) => {

    const truck = {
        ...data,
        availableFrom: momentToDtoString(data.availableFrom),
        availableTo: momentToDtoString(data.availableTo),
        recurrence: {
            ...data.recurrence,
            startDate: data.recurrence.startDate ?
                momentToDtoString(data.recurrence.startDate) : data.recurrence.startDate,
            endDate: data.recurrence.endDate ?
                momentToDtoString(data.recurrence.endDate) : data.recurrence.endDate
        }
    };

    return api.put(`api/trucks/${truck.id}`, truck).then(response => {
        if (response.status === 200) {
            return true;
        }

        return false;
    }).catch(error => false);
}

export const deleteTruck = (data: DeleteTruckModel): Promise<boolean> => {
    return api.post("api/trucks/delete", data).then(response => {
        if (response.status === 200) {
            return true;
        }
        return false;
    });
}

export const getTrucks = (filters?: FilterInfo): Promise<TruckModel[]> => {
    const filterUrl = createFilterUrl(filters);

    return api.get(getEndpoint + filterUrl).then(response => {
        if (response.status === 200) {
            const data = <TruckDto[]>response.data;

            return data.map(item => {
                return {
                    ...item,
                    availableFrom: moment(item.availableFrom),
                    availableTo: moment(item.availableTo),
                    deletedAt: item.deletedAt ? moment(item.deletedAt) : undefined,
                    recurrence: {
                        ...item.recurrence,
                        startDate: item.recurrence.startDate ?
                            moment(item.recurrence.startDate) : item.recurrence.startDate,
                        endDate: item.recurrence.endDate ?
                            moment(item.recurrence.endDate) : item.recurrence.endDate
                    }
                }
            });
        }

        return [];
    }).catch(error => {
        return [];
    });
}

export const getDeletedReasons = () => {
    return api.get("api/trucks/deletereasons").then(response => {
        if (response.status === 200) {
            return <DeletedReasonModel[]>response.data;
        }
        return [];
    });
}

export const sendEmail = (id: string, message: string, emailAddress: string) => {
    return api.post(`api/trucks/${id}/sendemail`, { emailAddress, message })
    .then(response => response.status === 200)
}

export const sendEmailToReporter = (id: string, message: string) => {
    return api.post(`api/trucks/${id}/sendemailtoreporter`, { message })
    .then(response => response.status === 200)
}


// WEBPACK FOOTER //
// ./src/api/trucksApi.ts